import React from 'react';
import HeroSection from '../components/HeroSection';
import SinglesShowcase from '../components/SinglesShowcase';
import FeaturedProducts from '../components/FeaturedProducts';
import EventsShowcase from '../components/EventsShowcase';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <HeroSection />


      {/* Singles */}
      <SinglesShowcase />

      {/* Featured Products */}
      <FeaturedProducts />

      {/* Upcoming Events */}
      <EventsShowcase />
    </div>
  );
};

export default Home;
